<template>
  <div class="category-item ">
    <div class="text-center category-name-parent  ">
      <img :src="category.image"
           :alt="category.name" class="">
      <span class="text-center">{{ category.name }}</span>
    </div>
  </div>
</template>

<script>
import {CategoryCardProps} from "./CategoryCardProps";
import {CategoryCardComputed} from "./CategoryCardComputed";
import mCard313 from "../../Cards/Card313";
import mButton from "../../Tags/Button";

export default {
  name: "CategoryCardUnKnow300.vue",
  components: {mCard313, mButton},
  props: {
    ...CategoryCardProps,
  },
  computed: {
    ...CategoryCardComputed
  }
}
</script>

<style scoped>
.category-item {
  background: var(--dark) ;
  color: white ;
  cursor: pointer;
  width: 110px;
  border-radius: 4px;
  height: 100px;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-around;

}

.category-item img {
  height: auto;
  width: 50px;
  display: block;
  text-align: center;
  margin: auto;
}

.category-name-parent {
  font-size: 12px;
}

</style>